import { Route } from 'react-router';

export function getDashboardRoutes(hasSigmaEmbed: boolean) {
  if (!hasSigmaEmbed) return null;

  return <Route path="dashboard" id="dashboard-root" lazy={() => import('routes/sigma-dashboard/dashboard.route')} />;
}
